export const categories = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-film-line",
    description: "汇聚院线热映与经典高分电影，从科幻巨制到现实主义佳作，快速找到值得一看的大银幕作品。",
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    description: "聚焦近年口碑与热度兼具的剧集，涵盖悬疑、年代、家庭、科幻等题材，追剧不再迷路。",
  },
  {
    slug: "china",
    name: "国产",
    icon: "ri-building-2-line",
    description: "精选国产影视佳作，展现本土创作力量与时代故事，感受华语影视的多元表达。",
  },
  {
    slug: "overseas",
    name: "海外",
    icon: "ri-earth-line",
    description: "网罗全球优秀电影与剧集，跨越语言与文化边界，带你领略世界影坛的精彩。",
  },
  {
    slug: "popular",
    name: "热门",
    icon: "ri-fire-line",
    description: "根据播放热度与讨论声量实时汇总，本季度最受关注的影视作品一站看齐。",
  },
];